import { render, staticRenderFns } from "./MonthlyEPFAmbank.vue?vue&type=template&id=a237de02"
import script from "./MonthlyEPFAmbank.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFAmbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports